import type { IconSvgObject } from './types';

const XLineTopIcon: IconSvgObject = [
  ["path", { d: "M18 8L12 14M12 14L6 20M12 14L18 20M12 14L6 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 4H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default XLineTopIcon;
